// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-header {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  width: 100%;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0;
  background: #fff;
  padding: 1.5rem;
}
.accordion-header .title {
  margin-bottom: 0;
  color: #1c2f56;
  text-align: left;
  margin-right: 1rem;
  font-weight: 500;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.accordion-header .arrow-icon {
  height: 22px;
  width: 22px;
}
.accordion-header .rotate-0 {
  transition: 0.4s;
  transform: rotate(0);
}
.accordion-header .rotate-90 {
  transition: 0.4s;
  transform: rotate(90deg);
}

.accordion-body-container {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  margin-bottom: 1rem;
  margin-top: 0.2rem;
  border-radius: 5px;
}
.accordion-body-container .accordion-body {
  padding: 1.5rem;
  background: #fff;
  color: gray;
  font-size: 0.95rem;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/common/accordion.scss"],"names":[],"mappings":"AAAA;EACE,2CAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AACF;AACE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;AACJ;AAEE;EACE,YAAA;EACA,WAAA;AAAJ;AAGE;EACE,gBAAA;EACA,oBAAA;AADJ;AAIE;EACE,gBAAA;EACA,wBAAA;AAFJ;;AAMA;EACE,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAHF;AAKE;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,iDAAA;AAHJ","sourcesContent":[".accordion-header {\r\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n  width: 100%;\r\n  border-radius: 5px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border: 0;\r\n  background: #fff;\r\n  padding: 1.5rem;\r\n\r\n  .title {\r\n    margin-bottom: 0;\r\n    color: #1c2f56;\r\n    text-align: left;\r\n    margin-right: 1rem;\r\n    font-weight: 500;\r\n    font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n  }\r\n\r\n  .arrow-icon {\r\n    height: 22px;\r\n    width: 22px;\r\n  }\r\n\r\n  .rotate-0 {\r\n    transition: .4s;\r\n    transform: rotate(0);\r\n  }\r\n\r\n  .rotate-90 {\r\n    transition: .4s;\r\n    transform: rotate(90deg);\r\n  }\r\n}\r\n\r\n.accordion-body-container {\r\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n  margin-bottom: 1rem;\r\n  margin-top: .2rem;\r\n  border-radius: 5px;\r\n\r\n  .accordion-body {\r\n    padding: 1.5rem;\r\n    background: #fff;\r\n    color: gray;\r\n    font-size: .95rem;\r\n    font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
